import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/advertisements/index.js